module.exports = __webpack_public_path__ + "img/2.c164bdd4.png";